import { useCMSPageField } from '@/cms/fields'
import { CollectionCard } from '@/scopes/common/components/CollectionCard'

import { CollectionId } from '@/scopes/common/components/CollectionCard/types'

export function CollectionBanner() {
  const collection = useCMSPageField('PDP.CollectionInformation')
  const collectionId: CollectionId | undefined = collection?.id
  const title = collection?.title
  const description = collection?.description
  const usps = collection?.usps || []

  if (!collection || !collectionId || !title || !description)
    return false

  return (
    <CollectionCard
      collectionId={collectionId}
      title={title}
      name={title}
      description={description}
      usps={usps}
    />
  )
}
